import {useMemo} from 'react';
import PropTypes from 'prop-types';
import {ProgressIndicator} from '@/components/atoms';
import {Setup, Display, Review} from '@/containers/ClubPlus/CreateTier/phases';
import './createTierContainer.scss';
import {useIntl} from 'react-intl';

const PHASES = [Setup, Display, Review];

export const CreateTierContainer = ({
  setPhase,
  phase,
  isEditMode = true,
  onEdit,
  lastUpdated,
  isEditingExistingTier = false,
  tierData
}) => {
  const {formatMessage} = useIntl();

  const CurrentPhase = useMemo(() => {
    return PHASES[phase - 1] || PHASES[0];
  }, [phase]);

  const titles = useMemo(
    () => [
      {title: formatMessage({id: 'CLUB_PLUS.TIER_CREATE_SETUP_TITLE'})},
      {title: formatMessage({id: 'CLUB_PLUS.TIER_CREATE_DISPLAY_TITLE'})},
      {title: formatMessage({id: 'CLUB_PLUS.TIER_CREATE_REVIEW_TITLE'})}
    ],
    [formatMessage]
  );

  const formatLastUpdated = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  };

  return (
    <>
      {isEditMode ? (
        <ProgressIndicator
          currentStep={phase}
          completed={false}
          orientation='horizontal'
          steps={3}
          titles={titles}
          className='mb-6 mt-8'
        />
      ) : (
        <div className='mb-6 mt-8'>
          {lastUpdated && (
            <div className='text-sm text-gray-400'>
              Last Update: {formatLastUpdated(lastUpdated)}
            </div>
          )}
        </div>
      )}
      <CurrentPhase
        key={phase}
        setPhase={setPhase}
        isEditMode={isEditMode}
        onEdit={onEdit}
        isEditingExistingTier={isEditingExistingTier}
        tierData={tierData}
      />
    </>
  );
};

CreateTierContainer.propTypes = {
  setPhase: PropTypes.func.isRequired,
  phase: PropTypes.number.isRequired,
  isEditMode: PropTypes.bool,
  onEdit: PropTypes.func,
  lastUpdated: PropTypes.string,
  isEditingExistingTier: PropTypes.bool,
  tierData: PropTypes.object
};
